"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Experience = void 0;
var react_dom_1 = __importDefault(require("react-dom"));
var react_1 = __importDefault(require("react"));
var MainUI_1 = require("./ui/MainUI");
var GameManager_1 = require("./game/GameManager");
var Events_1 = require("./util/events/Events");
var ScreenChangeEvent_1 = require("./ui/events/ScreenChangeEvent");
var LevelManager_1 = require("./game/LevelManager");
var AppCore_1 = require("./AppCore");
var ScreenChangeEvent_2 = require("./events/ScreenChangeEvent");
var ScoreManager_1 = require("./game/ScoreManager");
var GameScoreData_1 = require("./game/Score/GameScoreData");
var Experience = /** @class */ (function (_super) {
    __extends(Experience, _super);
    function Experience(platformType) {
        var _this = _super.call(this) || this;
        _this._appCore = new AppCore_1.AppCore(platformType);
        _this._appCore.addEventListener(ScreenChangeEvent_2.AppCoreReadyEvent.APP_READY, _this.onAppDataReady.bind(_this));
        _this.renderAppView();
        return _this;
    }
    Experience.prototype.onAppDataReady = function () {
        var data = new GameScoreData_1.GameScoreData();
        this._gameManager = new GameManager_1.GameManager(new LevelManager_1.LevelManager(this._appCore.levels), new ScoreManager_1.ScoreManager(data));
        this.changeScreen(MainUI_1.AppScreen.Menu);
    };
    Experience.prototype.startGame = function () {
        this._gameManager.start();
    };
    Experience.prototype.checkAnswer = function (combinedWord) {
        var answerCorrect = this._gameManager.checkAndScoreAnswer(combinedWord);
        if (answerCorrect === false) {
            console.log("Answer incorrect");
            return false;
        }
        var levelComplete = this._gameManager.hasCompletedLevel();
        if (levelComplete === true) {
            this.changeScreen(MainUI_1.AppScreen.LevelComplete);
            return false;
        }
        return true;
    };
    Experience.prototype.currentWord = function () {
        return this._gameManager.getCurrentWord();
    };
    Experience.prototype.currentLevel = function () {
        return this._gameManager.getCurrentLevel();
    };
    Experience.prototype.endGame = function () {
        this._gameManager.end();
        var nextLevel = this._gameManager.getCurrentLevel();
        if (nextLevel == null) {
            // Out of levels! boo! oh well
            this.changeScreen(MainUI_1.AppScreen.GameComplete);
        }
        else {
            // Play next level
            this.changeScreen(MainUI_1.AppScreen.Game);
        }
    };
    Experience.prototype.gameComplete = function () {
        this._gameManager.end();
        this.changeScreen(MainUI_1.AppScreen.Menu);
    };
    Experience.prototype.changeScreen = function (screen) {
        this.dispatchEvent(new ScreenChangeEvent_1.ScreenChangedEvent(ScreenChangeEvent_1.ScreenChangedEvent.SCREEN_CHANGED, screen));
    };
    Experience.prototype.renderAppView = function () {
        react_dom_1.default.render(react_1.default.createElement(MainUI_1.MainUI, { app: this }), document.getElementById("app"));
    };
    Object.defineProperty(Experience.prototype, "gameManager", {
        get: function () { return this._gameManager; },
        enumerable: false,
        configurable: true
    });
    return Experience;
}(Events_1.EventDispatcher));
exports.Experience = Experience;
